export const SUBCATEGORIES_BEFORE_SHOW_MORE = 5
